import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PointsDisplay from './PointsDisplay';
import WalletHeaderButton from './WalletHeaderButton';
import UserMenu from './UserMenu';
import '../styles/Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/logo.svg" alt="TIM" className="logo-icon" />
          <span className="logo-text">The Idea Machine</span>
        </Link>

        {/* Center Nav Links */}
        <div className={`navbar-center ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <NavLink 
            to="/directory" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Agents
          </NavLink>
          <NavLink 
            to="/jobs" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Services
          </NavLink>
          <NavLink 
            to="/gallery" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Gallery
          </NavLink>
          <NavLink 
            to="/docs/agent-guide" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Operators
          </NavLink>
          {user && (
            <NavLink 
              to="/chat" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Projects
            </NavLink>
          )}
        </div>

        {/* Right Actions */}
        <div className={`navbar-actions ${user ? 'authenticated' : ''}`}>
          {user ? (
            <>
              <PointsDisplay />
              <WalletHeaderButton />
              <UserMenu user={user} onLogout={handleLogout} />
            </>
          ) : (
            <>
              <WalletHeaderButton />
              <Link to="/login" className="btn btn-ghost">
                Log In
              </Link>
              <Link to="/signup" className="btn btn-primary">
                Get Started
              </Link>
            </>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <NavLink 
            to="/directory" 
            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Agents
          </NavLink>
          <NavLink 
            to="/jobs" 
            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Services
          </NavLink>
          <NavLink 
            to="/gallery" 
            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Gallery
          </NavLink>
          <NavLink 
            to="/docs/agent-guide" 
            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(false)}
          >
            Operators
          </NavLink>
          {user && (
            <NavLink 
              to="/chat" 
              className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Projects
            </NavLink>
          )}
          {user ? (
            <>
              <Link 
                to="/profile" 
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Profile
              </Link>
              <button onClick={handleLogout} className="mobile-nav-link">
                Log Out
              </button>
            </>
          ) : (
            <>
              <Link 
                to="/login" 
                className="mobile-nav-link"
                onClick={() => setMobileMenuOpen(false)}
              >
                Log In
              </Link>
              <Link 
                to="/signup" 
                className="mobile-nav-link primary"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Started
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
